/**
 * LadderNumberField - Wrapper component for LadderNumberInput that handles be    return (
        <InputNumber
            value={displayValue}
            onChange={handleChange}
            onBlur={handleBlur}
            min={min}
            max={max}
            step={step || 0.01}
            formatter={formatNumber}
            size="sm"
            style={{ width: '6rem' }}
            {...props}
        />
    );
 * ARCHITECTURE:
 * - Provides a wrapper around LadderNumberInput with custom behavior logic
 * - Handles value changes and validation
 * - Integrates with debug components
 * 
 * RESPONSIBILITIES:
 * - Wrap LadderNumberInput with additional behavior
 * - Handle value validation and clamping
 * - Provide consistent interface for number input fields
 */

import React, { useCallback } from 'react'
import useBuildScenarioStore, {
  useScenarioDriverValue,
} from '../../../../stores/buildScenarioStore'
import { StyledInputNumber } from './styles/InputNumber.styles'
import { useInputValueManager } from './utils/useInputValueManager'
import { formatNumber, safeParseNumber } from './utils/formatters'

const LadderNumberField = ({
  scenarioId,
  driverId,
  min,
  max,
  step,
  ...props
}) => {
  const driverValueObject = useScenarioDriverValue(scenarioId, driverId)
  const setScenarioDriverValue = useBuildScenarioStore(
    (state) => state.setScenarioDriverValue,
  )

  // Convert string values to numbers for InputNumber
  const baseNumericValue = safeParseNumber(driverValueObject.value)

  const applyValueChange = useCallback(
    (value) => {
      // More robust value checking and ensure it's a number
      if (value !== null && value !== undefined && !isNaN(value)) {
        const numericValue = safeParseNumber(value)
        setScenarioDriverValue(scenarioId, driverId, numericValue)
      }
    },
    [scenarioId, driverId, setScenarioDriverValue],
  )

  const { handleChange, handleBlur, displayValue } = useInputValueManager(
    baseNumericValue,
    applyValueChange,
    min, // Pass min and max to the hook for clamping
    max,
  )

  return (
    <StyledInputNumber
      value={displayValue}
      onChange={handleChange}
      onBlur={handleBlur}
      min={min}
      max={max}
      step={step || 0.01}
      formatter={formatNumber}
      size="sm"
      color={'white'}
      style={{ width: '5.5rem' }}
      {...props}
    />
  )
}

export default LadderNumberField
